import { PRIMARY } from 'constants/colors';

import { brightness } from 'utils/misc';

import { Box, styled } from '@mui/material';

const GridStyleWrapper = styled(Box)(({ theme }) => ({
  width: '100%',

  '.MuiDataGrid-columnHeaders': {
    borderBottom: `2px solid ${theme.palette.primary.main}`
  },

  '.MuiDataGrid-row': {
    fontFamily: '"SourceSansPro-Regular",Arial,sans-serif'
  },
  '.MuiDataGrid-row:hover': {
    backgroundColor: 'inherit'
  },
  '.MuiTablePagination-root p': {
    margin: 0
  },
  '.MuiDataGrid-cell--editing': {
    padding: '0 4px !important',
    backgroundColor: `${brightness(PRIMARY, 90)} !important`
  },
  '.MuiDataGrid-cell': {
    display: 'flex',
    alignItems: 'center'
  },
  // First column header when focused
  '.MuiDataGrid-columnHeader[aria-colindex="1"]:focus': {
    borderTopLeftRadius: theme.shape.borderRadius
  },

  // Last column header when focused
  '.MuiDataGrid-columnHeader:focus:not(:has(~ .MuiDataGrid-columnHeader))': {
    borderTopRightRadius: theme.shape.borderRadius
  }
}));

export default GridStyleWrapper;
